module.exports = __webpack_public_path__ + "img/Zimmer_Blumen.49363073.jpg";